import { USER_RIGHTS_QUERY } from '../queries';
import { getListBrowserStore } from '@ts-private/list-browser';
export const store = getListBrowserStore({
    name: 'user-rights-browser',
    filterDefinitions: [], orderByFields: [], pager: {}
  });
  
  export const fetchOptions = {
    queryOptions: { query: USER_RIGHTS_QUERY, name: 'userRights', fetchPolicy: 'network-only' }
  };
  